import React, { Suspense, useState } from 'react'
import { useTranslation, I18nextProvider } from 'react-i18next'
import bmiCalculatorI18n from './utils/i18n'
import { StateProvider } from './context/StateContext'
import './scss/main.scss'
import { workflowEvent } from '../../utils/tracking'
import Adult from './components/Adult'
import Child from './components/Child'
import ChildAge from './components/ChildAge'
import ChildGender from './components/ChildGender'
import Start from './components/Start'
import Results from './components/Results'

function BmiCalculator() {
  const initialState = {
    step: 'start',
    bmi: null,
    adult: false,
    child: false,
    gender: null,
    age: null,
    ageInMonths: null,
    height: null,
    weight: null,
  }

  const [state, setState] = useState(initialState)
  const { t } = useTranslation()

  function renderStep() {
    workflowEvent(
      'bmi-calculator',
      state.step,
      state.step === 'results' ? 1 : 0
    )

    switch (state.step) {
      case 'start':
        return <Start />
      case 'adult-height-weight':
        return <Adult />
      case 'child-gender':
        return <ChildGender />
      case 'child-dob':
        return <ChildAge />
      case 'child-height-weight':
        return <Child />
      case 'results':
        return <Results />
      default:
        return null
    }
  }

  return (
    <StateProvider value={{ state, setState }}>
      <div className="bmi-calculator">
        <div className="bmi-calculator__container">
          <div className="bmi-calculator__header">
            <h2 className="title">{t('title')}</h2>
            <p>{t('intro-text')}</p>
          </div>
          <div className="bmi-calculator__tool">{renderStep()}</div>
          <div className="bmi-calculator__caveat">
            <p className="bmi-calculator__text">{t('caveat')}</p>
          </div>
        </div>
      </div>
    </StateProvider>
  )
}

// export default BmiCalculator
export default function WrappedBmiCalculator() {
  return (
    <Suspense fallback="...is loading">
      <I18nextProvider i18n={bmiCalculatorI18n}>
        <BmiCalculator />
      </I18nextProvider>
    </Suspense>
  )
}
